import { Banner } from 'components/Banner/Banner'
import { useContractBulkTableConfigContext } from '../Providers/ContractBulkTableConfigProvider'
import { NoCategoriesWarning } from 'features/ContractDetails/ContractDetailsGeneral/ContractDetailsForm/AddContractCategory/NoCategoriesWarning'

export const ContractBulkBanner = () => {
  const { state } = useContractBulkTableConfigContext()
  if (state.errorLabel.length) {
    return <Banner.Error text={state.errorLabel} className="mt-24" />
  }
  if (state.noCategoriesAvailable) {
    return <NoCategoriesWarning className="mt-24" />
  }
  return null
}
